import * as IconSelector from '../icons';

// Constantes exportadas
export const INCIDENCE_PARCEL_COSECHA_EN_VERDE = 'Cosecha en Verde';
export const INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_CAMPO =
    'Exceso Rendimiento Campo';
export const INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_DECLARADO =
    'Exceso Rendimiento Declarado';
export const INCIDENCE_PARCEL_NO_GRADO_MINIMO = 'No grado minimo';

// Definición del enum
export const incidenceParcel = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido una incidencia',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: INCIDENCE_PARCEL_COSECHA_EN_VERDE,
        label: 'Cosecha en Verde',
        description: 'Se ha bloqueado porque ha realizado consecha en verde',
        icon: IconSelector.RecolectionIcon,
        color: 'green'
    },
    {
        value: INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_CAMPO,
        label: 'Exceso Rendimiento Campo',
        description:
            'Se ha bloqueado porque tiene exceso de rendimiento detectado en campo',
        icon: IconSelector.InspeccionesIcon,
        color: 'red'
    },
    {
        value: INCIDENCE_PARCEL_EXCESO_RENDIMIENTO_DECLARADO,
        label: 'Exceso Rendimiento Declarado',
        description: 'Tiene exceso de rendimiento en la declaración',
        icon: IconSelector.ExceedIcon,
        color: 'darkred'
    },
    {
        value: INCIDENCE_PARCEL_NO_GRADO_MINIMO,
        label: 'No grado minimo',
        description: 'No cumple con el grado definido en el pliego',
        icon: IconSelector.BaumeIcon,
        color: 'darkorange'
    }
];
